import * as React from "react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import WorkIcon from "@mui/icons-material/Work";
import ChevronRightSharpIcon from "@mui/icons-material/ChevronRightSharp";
import { useHistory } from "react-router";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { ProvidersAffiliateOrders, USER } from "../../constants/provider/constant";
import { languagesMap, offlineConsultsTabs } from "../../components/centralOms/common/constants";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { HowToUse } from "../../components/centralOms/common/howToUseDialog";

export default function NestedList(props) {
  const history = useHistory();
  const [open, setOpen] = React.useState(true);
  const [openHTU, setOpenHTU] = React.useState(false);
  const providerId = USER && USER.user.providerId;
  const entityName = USER && USER.user.entityName;
  const [howToUseDialogVisible, setHowToUseDialogVisibiliy] = React.useState(false);
  const [videoURL, setVideoURL] = React.useState(languagesMap["English"]);

  const lists =
    props.service == "LABS"
      ? [
          { id: 1, name: "New Appointments", route: "/appointments" },
          { id: 2, name: "Confirmed Appointments", route: "/appointments/confirmed" },
          { id: 3, name: "Documents Pending", route: "/documents/pending" },
          { id: 4, name: "Documents Pending", route: "/documents/partialReceived" },
          { id: 5, name: "Documents Submitted", route: "/documents/received" },
          { id: 6, name: "Settled", route: "/cases/settled" },
          { id: 7, name: "Cancelled", route: "/cases/cancelled" },
        ]
      : offlineConsultsTabs;

  const routesTo = (route) => {
    if (props.service == "LABS") {
      history.push("/" + localStorage.getItem("roleName") + route);
    } else {
      history.push(route);
    }
    props.toggleDrawerFunction();
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const roleName = localStorage.getItem("roleName");

  return (
    <>
      <List
        aria-labelledby="nested-list-subheader"
        subheader={
          entityName ? (
            <ListSubheader component="div" className="p-0" id="nested-list-subheader" sx={{ padding: 0 }}>
              <div className="font-semibold bg-nested-menu-header leading-tight pt-4 pb-6 px-4">
                <div>{entityName}</div>
              </div>
            </ListSubheader>
          ) : (
            ""
          )
        }
      >
        <ListItemButton>
          {roleName === "dcadmin" ? (
            <ListItemIcon onClick={() => history.push("/dashboard")}>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Admin Dashboard" />
            </ListItemIcon>
          ) : (
            <></>
          )}
        </ListItemButton>
        <ListItemButton onClick={handleClick}>
          <ListItemIcon>
            <WorkIcon />
          </ListItemIcon>
          <ListItemText primary="Appointments" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {lists ? (
              lists.map((elem, index) => (
                <ListItemButton key={index} sx={{ pl: 3 }} onClick={() => routesTo(elem.route)}>
                  <ListItemIcon>
                    <ChevronRightSharpIcon />
                  </ListItemIcon>
                  <span className="text-sm">{elem.name}</span>
                </ListItemButton>
              ))
            ) : (
              <></>
            )}
          </List>
        </Collapse>
        <ListItemButton onClick={() => setOpenHTU(!openHTU)}>
          <ListItemIcon>
            <PlayCircleIcon />
          </ListItemIcon>
          <ListItemText primary="How To Use" />
          {openHTU ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openHTU} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {Object.keys(languagesMap).map((elem, index) => (
              <ListItemButton key={index} sx={{ pl: 3 }} 
                onClick={() => {
                  setHowToUseDialogVisibiliy(true); 
                  setVideoURL(languagesMap[elem])
                }
              }>
                <ListItemIcon>
                  <ChevronRightSharpIcon />
                </ListItemIcon>
                <span className="text-sm">{elem}</span>
              </ListItemButton>
            ))}
          </List>
        </Collapse>
        {ProvidersAffiliateOrders.includes(providerId) && (
          <ListItemButton onClick={() => routesTo("/create/order")}>
            <ListItemIcon>
              <AddCircleRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Create Order" />
          </ListItemButton>
        )}
      </List>

      {howToUseDialogVisible && <HowToUse visible={howToUseDialogVisible} setVisibility={setHowToUseDialogVisibiliy} videoURL={videoURL}></HowToUse>}
    </>
  );
}
